import { paths } from "helpers/paths";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { getDocumentFile } from "sources/billing";

export default function BillingDocumentDownload(props) {
    const documentId = useMemo(() => Number(props.match.params.id), [props.match.params.id]);
    const isValidDocumentId = Number.isInteger(documentId) && documentId > 0;
    const [loading, setLoading] = useState(isValidDocumentId);

    const downloadDocument = useCallback(() => {
        if (!isValidDocumentId) {
            return;
        }

        setLoading(true);
        getDocumentFile(documentId)
            .catch(() => undefined)
            .finally(() => setLoading(false));
    }, [documentId, isValidDocumentId]);

    useEffect(() => {
        downloadDocument();
    }, [downloadDocument]);

    if (!isValidDocumentId) {
        return (
            <div className="py-4 text-center">
                <div className="mb-3 text-muted">Некорректная ссылка на документ.</div>
                <Link className="btn btn-sm btn-secondary" to={paths.profileBillingDocuments}>
                    Перейти к документам
                </Link>
            </div>
        );
    }

    return (
        <div className="py-4 text-center">
            <div className="mb-3 text-muted">
                {loading ? "Скачивание документа..." : "Если загрузка не началась, скачайте документ повторно."}
            </div>
            <button className="btn btn-sm btn-brand" type="button" disabled={loading} onClick={downloadDocument}>
                Скачать документ
            </button>
        </div>
    );
}
